import { axiosInstance } from "../services/axiosInstance";
import catchAsync from "../utils/catchAsync";

export const addService = catchAsync(async (body, locationId) => {
  const data = await axiosInstance.post(`salon/${locationId}/services`, body);
  return data;
});

export const showServiceCategory = catchAsync(async (categoryId) => {
  const { data } = await axiosInstance.get(
    `salon/service-categories/${categoryId}`
  );
  return data;
});

export const getAllCategories = catchAsync(async () => {
  const { data } = await axiosInstance.get("salon/service-categories");
  return data;
});

export const getListServices = catchAsync(async (locationId) => {
  const { data } = await axiosInstance.get(`salon/${locationId}/services`);
  return data;
});

export const getListServicesuncategorized = catchAsync(async (locationId) => {
  const { data } = await axiosInstance.get(
    `salon/${locationId}/uncategorized-services`
  );
  return data;
});

export const listTreatmentTypes = catchAsync(async () => {
  const { data } = await axiosInstance.get("salon/treatment-types");
  return data;
});

export const getAllServices = catchAsync(async (locationId, search = null) => {
  let query = "";
  if (search) {
    query = query + "?search=" + search;
  }
  let url = `salon/${locationId}/services` + query;
  const { data } = await axiosInstance.get(url);
  return data;
});

export const listParentwithServices = catchAsync(async (params) => {
  const { data } = await axiosInstance.get("salon/all-services", { params });
  return data;
}); //! maybe we stopped  using  it after
export const listServicesCategories = catchAsync(async (params) => {
  let url = "salon/service-categories";
  const { data } = await axiosInstance.get(url, {
    params,
  });
  return data;
});

export const getServiceDetails = catchAsync(async (locationId, serviceId) => {
  let url = `salon/${locationId}/services/${serviceId}`;
  const { data } = await axiosInstance.get(url, {
    headers: {
      "x-translations": true,
    },
  });
  return data;
});

export const getPackageDetails = catchAsync(async (locationId, packageId) => {
  let url = `salon/${locationId}/packages/${packageId}`;
  const { data } = await axiosInstance.get(url, {
    headers: {
      "x-translations": true,
    },
  });
  return data;
});

export const deleteService = catchAsync(async (serviceId, locationId) => {
  // console.log(serviceId, locationId);
  // return;
  const { data } = await axiosInstance.delete(
    `salon/${locationId}/services/${serviceId}`
  );
  return data;
});

export const updateService = catchAsync(async (body, locationId, serviceId) => {
  const data = await axiosInstance.put(
    `salon/${locationId}/services/${serviceId}`,
    body
  );
  return data;
});
